import React from 'react';

const CopyIcon: React.FC = () => {
  return (
    <svg width="1em" height="1em" fill="none">
      <path
        d="M13.333 6h-6C6.597 6 6 6.597 6 7.333v6c0 .737.597 1.334 1.333 1.334h6c.737 0 1.334-.597 1.334-1.334v-6c0-.736-.597-1.333-1.334-1.333z"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.333 10h-.666a1.333 1.333 0 01-1.333-1.333v-6a1.333 1.333 0 011.333-1.334h6A1.333 1.333 0 0110 2.667v.666"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default CopyIcon;
